<template>
  <div
    class="slide-thumbnail"
    :data-template-id="template.id"
    :style="{ 'background-color': template.baseColour, 'color': template.textColour }"
    v-on="$listeners"
  >
    <!-- <div
      v-if="template.metadata && template.metadata.thumbnailUrl"
      class="thumbnail-image"
      :style="{
        'background-image': 'url(' + template.metadata.thumbnailUrl + ')',
      }"
      :class="getSlideBgSize(template.backgroundSize)"
    /> -->
    <!-- <div class="absolute top-0 left-0 w-full h-full" v-else> -->
    <div
      v-if="thumbnailImage"
      class="thumbnail-image"
      :style="{
        'opacity': template.visibility / 100,
        'background-image': 'url(' + thumbnailImage + ')',
      }"
      :class="getSlideBgSize(template.backgroundSize)"
    />
    <FreestyleThumbnailPreview
      :slide="template"
      :readonly="true"
      :location="'templates'"
    />
    <!-- </div> -->
  </div>
</template>

<script>
import FreestyleThumbnailPreview from '@/components-v2/presentation-editor/side-left/FreestyleThumbnailPreview.vue'

export default {
  components: {
    FreestyleThumbnailPreview,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
  },
  computed: {
    thumbnailImage() {
      if (this.template.backgroundCache) return this.template.backgroundCache
      if (!this.template.backgroundImage) return null
      return this.template.backgroundImage.large
    },
  },
  mounted() {
  },
  methods: {
    getSlideBgSize(bgSize) {
      if (!bgSize) return 'bg-cover'
      return 'bg-contain'
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-thumbnail {
  @apply rounded relative cursor-pointer overflow-hidden;

  width: 154px;
    height: calc(154px / 16 * 9);
    margin-bottom: 16px;
    transition: box-shadow 0.3s ease;
    box-shadow: 0 0 1px 1px #d9deec;
    .thumbnail-image {
      @apply absolute w-full h-full top-0 left-0 bg-no-repeat bg-center rounded;
    }
    &:nth-child(odd) {
      margin-right:16px;
    }
    &:hover {
      box-shadow: 0 0 2px 1px #1781d7;
    }
}
</style>
